var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box, FormHelperText } from '@chakra-ui/react';
import React from 'react';
import ErrorMessageContainer from './ErrorMessageContainer';
var FormFieldMeta = function (_a) {
    var _b = _a.errors, errors = _b === void 0 ? {} : _b, name = _a.name, _c = _a.helperText, helperText = _c === void 0 ? '' : _c, _d = _a.helperTextStyles, helperTextStyles = _d === void 0 ? {} : _d, _e = _a.errorTextStyles, errorTextStyles = _e === void 0 ? {} : _e, dataTestId = _a.dataTestId;
    return (React.createElement(Box, { minH: 6 },
        React.createElement(ErrorMessageContainer, __assign({ errorDataTestId: "".concat(dataTestId, "-error"), errors: errors, mt: 0, name: name, position: 'relative' }, errorTextStyles)),
        !(errors === null || errors === void 0 ? void 0 : errors[name]) && (React.createElement(FormHelperText, __assign({ mt: 0 }, helperTextStyles), helperText || ''))));
};
export default FormFieldMeta;
//# sourceMappingURL=FormFieldMeta.js.map